import {newProductStepEnum} from '@/utils/constant'
export default {
  methods: {
    startTask(skuId, skuCode, taskId, spuId, render) {
      skuId instanceof Array ? skuId = skuId : skuId = [skuId];
      skuCode instanceof Array ? skuCode = skuCode : skuCode = [skuCode];
      const titleMap = {
        [newProductStepEnum.shooting]: '开始拍摄',
        [newProductStepEnum.retouching]: '开始修片',
        [newProductStepEnum.design]: '开始设计',
        [newProductStepEnum.sectioning]: '开始切片',
      };
      const title = render ? '开始渲染' : titleMap[taskId] || '';

      this.$confirm((<div class="jsx-content">
        确定{title}？
        <span style="color: #E63946; margin-top: 5px;">
          
        </span>
      </div>), title)
      .then(async () => {
        const loading = this.$loading({
          target: '.app-main',
          lock: true,
        });

        let params = [];
        skuId.forEach(item=>{
          params.push({
            skuId: item,
            remarks: '',
            spuId: spuId ? spuId : '',
            taskId: render ? 111 : spuId ? '' : taskId
          })
        })
        
        let result;
        if(render) {
          result = await this.startRendering(params)
        }else if (spuId) {
          result = await this.startRetouching(params);
        } else if(!spuId) {
          result = await this.startWork(params);
        }
        

        const {success} = result || {};
        if (success) {
          this.$notify.success({
            title: '成功',
            message: `${title}成功`,
          });
          if(skuId.length > 1) {
            this.updateAfterBatchOperation();
          }else{
            this.updateAfterOperation({skuId: skuId[0], skuCode: skuCode[0]});
          }
        }
        loading.close();
      })
      .catch(_=> {});
    },
    startWork(params) {
      return this.$q.newProduct.startWork({data: params})
        .catch(console.log);
    },
    startRetouching(params) {
      return this.$q.newProduct.startRetouching({data: params})
      .catch(console.log);
    },
    startRendering(params) {
      return this.$q.newProduct.startRendering({data: params})
      .catch(console.log);
    }
  }
}